(function(){

	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	const initializeBlock = function( $block ) {

		const container = $block[0];
		const carousel = container.querySelector('.logo-carousel');

		setupTheSlider(carousel);

	}


	/**
	 *
	 *
	 *
	 */
	const setupTheSlider = function( carousel ) {

		// @see https://github.com/metafizzy/flickity/issues/233

    // Flickity set-up
    var flkty;
    var elem = carousel;
    var groupCells;

    // Set-up the breakpoint variable
    var breakpoint;

    // Get the current breakpoint
    var getBreakpoint = function () {
      return window.getComputedStyle(document.body, ':before').content.replace(/"/g, '');
    };

    // Set the number of groupCells based on breakpoint
    var setCells = function () {
      if (breakpoint === 'xs') {
        return 1;
      } else if (breakpoint === 'sm') {
        return 2;
      } else if (breakpoint === 'md') {
        return 3;
      } else if (breakpoint === 'lg') {
        return 4;
      } else {
				return 5;
			}
    };

    // Calculate breakpoint on page load
    breakpoint = getBreakpoint();
    groupCells = setCells();
    console.log(groupCells);
    do_flickity();

    // Setup a timer
    var timeout;

    // Recalculate breakpoint on resize
    window.addEventListener('resize', function () {
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }
      timeout = window.requestAnimationFrame(function () {

        // Get the groupCells value from before resize
        var prevGroupCells = groupCells;

        // Get the new current breakpoint
        breakpoint = getBreakpoint();

        // Get the new groupCells value
        groupCells = setCells();

        // If new groupCells count is different from previous. DESTROY Flickity & init new Flickity
        // console.log(groupCells + ' | ' + prevGroupCells);
        if( groupCells !== prevGroupCells ){
          flkty.destroy();
          do_flickity();
        }

      });
    }, false);

    // init Flickity
    function do_flickity() {
      flkty = new Flickity( elem, {
        groupCells: groupCells,
				cellAlign: 'left',
				contain: true,
        draggable: false,
				imagesLoaded: true,
				lazyLoad: true,
				pageDots: false,
				wrapAround: true
      });
    }
	}


	// Initialize each block on page load (front end).
	if ( !document.body.classList.contains('wp-admin') ) {
		const logoCarousels = document.querySelectorAll('.logo-carousel');
		logoCarousels.forEach( (carousel) => {
			setupTheSlider(carousel);
		} );
	}


	// Initialize dynamic block preview (editor).
	if ( window.acf ) {
		window.acf.addAction( 'render_block_preview/type=logo-carousel', initializeBlock );
	}

})();